import React from 'react';
import { Row, Col } from 'reactstrap';
import Moment from 'moment';
import { Link } from 'react-router-dom';

const CampaignRow = ({ campaign }) => {
  if (!campaign) return null;

  Moment.locale('en-au');

  return (
    <div>
      <Row className='campaign-row'>
        <Col md='1' className='white-border'>
          {campaign.source}
        </Col>
        <Col md='1' className='white-border'>
          <Link to={`/campaign/${campaign.id}`} className='row-link-active'>
            {campaign.externalId}
          </Link>
        </Col>
        <Col md='5' className='white-border'>
          <Link to={`/campaign/${campaign.id}`} className='row-link-active'>
            {campaign.name} - {campaign.description}
          </Link>
        </Col>
        <Col md='1' className='white-border'>
          {Moment(campaign.startDate).format('DD MMM YYYY')}
        </Col>
        <Col md='1' className='white-border'>
          {Moment(campaign.endDate).format('DD MMM YYYY')}
        </Col>
        <Col md='1' className='white-border'>
          {campaign.status}
        </Col>
        <Col md='2' className='white-border'>
          <Link
            to={`/campaign/${campaign.id}/add-promotion`}
            className={`btn btn-primary${campaign.isReadOnly ? ' disabled' : ''}`}
          >
            Add Promotion
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default CampaignRow;
